import { common } from "../../../../config/style-configs/common";

export const styles = {
  style: {
    flex: 1
  },
  loading: common.loading,
  buttonReminder: common.listButtonReminderContainer,
  errorMessage: common.containerErrorMessage,
  rightElement: {
    flexDirection: "row",
    alignItems: "center"
  },
  rightElementText: {
    marginRight: 8,
    color: "#666",
    maxWidth: "clamp(120px, calc(100vw - 280px), 320px)",
    flexShrink: 1
  }
};
